import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=5a5043d8&scoped=true&"
import script from "./EmailConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailConfirm.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=5a5043d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5043d8",
  null
  
)

export default component.exports